function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { useCallback } from "react";
import { useTopicButton_SetTopicFollowMutation, ItemType, FollowStatus } from "sprout-graphql";
import { useSnackbar } from "sprout-ui-dom/dist/Snackbar";
import useCurrentUser from "@sprout/client-graphql/dist/useCurrentUser";
import active from "@sprout/client-lib/dist/active";
import { useBus } from "sprout-ui-dom/dist/Bus";
function useSetTopicFollow({ topicId , amFollowing , nodeId , title  }) {
    const currentUser = useCurrentUser();
    const showSnackbar = useSnackbar();
    const eventBus = useBus();
    /**
   * ignore: false - following
   * ignore: true - ignoring
   * ignore: null - null
   */ const [setTopicFollow] = useTopicButton_SetTopicFollowMutation({
        variables: {
            topicId,
            ignore: !!amFollowing
        },
        optimisticResponse: {
            setTopicFollow: {
                query: {
                    nodeId: "query",
                    itemById: {
                        nodeId,
                        id: topicId,
                        type: ItemType.Topic,
                        currentUserFollowStatus: amFollowing ? FollowStatus.Ignoring : FollowStatus.Following,
                        __typename: "Item"
                    },
                    __typename: "Query"
                },
                __typename: "SetTopicFollowPayload"
            }
        }
    });
    return useCallback(_asyncToGenerator(function*() {
        if (!currentUser && !active(currentUser)) {
            eventBus.emit("dialog::auth::open");
            return;
        }
        try {
            yield setTopicFollow();
            showSnackbar({
                message: `You ${!amFollowing ? "followed" : "unfollowed"} ${title || "No title"}`
            });
        } catch (e) {
            showSnackbar.error();
        }
    }), [
        amFollowing,
        currentUser,
        eventBus,
        setTopicFollow,
        showSnackbar,
        title
    ]);
}
export default useSetTopicFollow;
